import { render, staticRenderFns } from "./AnnexDetails.vue?vue&type=template&id=59c652db&scoped=true"
import script from "./AnnexDetails.vue?vue&type=script&lang=js"
export * from "./AnnexDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnexDetails.vue?vue&type=style&index=0&id=59c652db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c652db",
  null
  
)

export default component.exports